import { system } from './system-core.esm.js';

// port from @styled-system/shadow v.5.1.2
var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

export default shadow;
export { shadow };
//# sourceMappingURL=shadow.esm.js.map
